import { render, staticRenderFns } from "./liveDistribute.vue?vue&type=template&id=01ddd283&"
import script from "./liveDistribute.vue?vue&type=script&lang=js&"
export * from "./liveDistribute.vue?vue&type=script&lang=js&"
import style0 from "./liveDistribute.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports